<div class="modal-content" [ngClass]="{'odometer-modal': brandInfo.odometerModal}">
  <div class="modal-header mb-n1">
    <span aria-hidden="true"><mdb-icon id="closeVehicleInspectionS3ModalIcon" tabindex="0" class="modal-close-icon" aria-label="Close"
    (click)="closeModal()" fas icon="times"></mdb-icon></span>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-12 text-center">
        @if (!brandInfo.odometerModal) {
          <div class="mb-0"><strong>Vehicle Inspection Document</strong></div>
        }
        @if (brandInfo.odometerModal) {
          <div class="mb-0 header"><strong>Odometer</strong></div>
        }
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 text-center mb-4">
        @if (brandInfo.brand !== 'Lambo') {
          <span>Upload or take a picture</span>
        }
        @if (brandInfo.brand === 'Lambo') {
          <span>Upload Selezione Program checklist</span>
        }
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="center" [ngClass]="{'upload-container': brandInfo.odometerModal}">
          <ngx-file-drop dropZoneLabel="Drop files here" (onFileDrop)="dropped($event)" (onFileOver)="fileOver($event)"
            accept=".pdf, .jpeg, .jpg, .png, .jfif" (onFileLeave)="fileLeave($event)">

            <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
              <div class="text-center upload-icon">
                <i class="fas fa-cloud-upload-alt" aria-hidden="true"></i>
              </div>
              <span class="pt-1">Drag and Drop or&nbsp;</span>
              <a id="chooseFileLinkS3" class="choose-file" (click)="openFileSelector()">Choose file</a>
              <span>&nbsp;to upload .pdf .png or .jpg.</span>
            </ng-template>
          </ngx-file-drop>

          @if (documents.length > 0) {
            <div class="upload-table">
              <table class="table">
                <thead>
                  <tr>
                    <th>File(s)</th>
                  </tr>
                </thead>
                <tbody class="upload-name-style">
                  @for (item of documents; track item; let i = $index) {
                    <tr>
                      <td><strong>{{ item.display_name }}</strong></td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          }
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 text-center mt-3 mb-3">
        <button id="uploadInspectionDocumentsButton" [disabled]="documents.length == 0 || isLoading" class="btn primary-btn waves-light uppercase" mdbBtn mdbWavesEffect
          (click)="uploadFiles(modalRef)">
          @if (!isLoading) {
            <span>Upload</span>
          }
          @if (isLoading) {
            <span>
              <i class="fas fa-spinner fa-spin me-2"></i> Uploading...
            </span>
          }
        </button>
      </div>
    </div>
    @if (brandInfo.brand === 'Lambo' && documents.length > 0 && !brandInfo.odometerModal) {
      <div class="row">
        <div class="col-md-12 mb-4 text-left">
          <span>By submitting this document, I confirm that the vehicle has passed the Lamborghini Selezione checklist and
          is eligible for Vehicle Service Protection.</span>
        </div>
      </div>
    }
    @if (brandInfo.brand === 'Porsche' && documents.length > 0 && !brandInfo.odometerModal) {
      <div class="row">
        <div class="col-md-12 mb-4 text-left">
          <span>By submitting this document, I confirm that the vehicle has passed the Porsche inspection checklist and is
          eligible for Vehicle Service Protection.</span>
        </div>
      </div>
    }
    @if (documents.length > 0 && brandInfo.odometerModal) {
      <div class="row">
        <div class="col-md-12 mb-4 text-left">
          <span>I confirm this is the current mileage on my vehicle's odometer</span>
        </div>
      </div>
    }
  </div>
</div>